// Match a spec line's text against the list of installed promotions.
// Returns the first matching promo or null. Kept as a standalone module so
// both HandlePromo (during recalculation) and SpecsSection (during render of
// already-persisted discounted lines) can share one definition.
export const getMatchedPromo = (promos, text) => {
  if (!text) return null;
  const normalized = text
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/[•‣▪●○■□▢◽◾◻◼◿✓✔✕✖✗✘✙✪✫✬✭✰✱✲✳✴✵✶✷✸✹✺✻✼✽✾✿❀❁❂❃❄❅❆❇❈❉❊❋❌❍❎❏❐❑❒❓❔❕❖❗❘❙❚❛❜❝❞❟❠❡❢❣❤❥❦❧✔]/g, '')
    .replace(/\t+/g, ' ')
    .replace(/\s+/g, '')
    .trim()
    .toLowerCase();

  for (const p of (promos || [])) {
    if (!p.visible) continue;
    const applies = p.applies_to?.trim();
    if (!applies) continue;

    const subRules = applies.split('<>').map(r => r.trim()).filter(Boolean);
    for (const rule of subRules) {
      if (!rule.includes(':')) continue;
      const normalizedRule = rule.replace(/[•✓✔✔]/g, '').replace(/\s+/g, '').trim().toLowerCase();
      if (normalizedRule.endsWith(':*')) {
        const prefix = normalizedRule.slice(0, -2);
        if (normalized.startsWith(prefix + ':')) return p;
      }
      if (normalized.includes(normalizedRule)) return p;
    }
  }
  return null;
};
